module.exports = __webpack_public_path__ + "img/golbal_pic.6da11885.jpg";